import { useTheme } from '@mui/material';

export const BOTTOM_NAV_HEIGHT = '50px';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    dashboardShortcuts: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '20px',
      position: 'absolute',
      right: '300px',
      top: 0,
      bottom: 0,
      left: 'auto',
    },
    dashShortcut: {
      fontSize: '30px',
      color: '#05A4D8',
    },
    dashShortcutMargin: {
      marginLeft: '12px',
    },
    footer: {
      backgroundColor: '#fafafa',
      position: 'absolute',
      bottom: 0,
      top: 'auto',
      left: 0,
      right: 0,
      height: BOTTOM_NAV_HEIGHT,
      zIndex: 4,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      boxShadow: '1px -1px 18px rgba(0, 0, 0, .175)',
    },
    footerLeft: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'center',
    },
    footerCenter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    footerRight: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      height: '100%',
      position: 'relative',
    },
    logoContainer: {
      display: 'flex',
      margin: theme.spacing(0, 4, 0, 6.5),
    },
    logoImage: {
      height: 24,
    },
  };
};
